import styles from "./Industri.module.css"
import React from "react"
import { Card } from "antd"

// logo line1
import KAIservice from "./Industri-img/KAI-Services.png"
import Halal from "./Industri-img/Total Quality.png"
import pigeon from "./Industri-img/Pigeon.png"
import sababay from "./Industri-img/Sababay.png"
import BUSKIPM from "./Industri-img/BUSKIPM.png"
import racelia from "./Industri-img/RacheliaBogarasaNusantara.png"
import indmira from "./Industri-img/Indmira.png"
import kkp from "./Industri-img/kkp.png"
import prakerja from "./Industri-img/Logo-kartu-prakerja.png"
import pingroun from "./Industri-img/PingrounFoodJakarta.png"
import trn from "./Industri-img/TatarasaNusantara.png"
import minaceria from "./Industri-img/Minaceria.png"
import kemenperin from "./Industri-img/Kemenperin.png"
// logo line2
import intrafood from "./Industri-img/Intrafood.png"
import pertamina from "./Industri-img/Pertamina-hulu-kaltim.png"
import casfood from "./Industri-img/casfood.jpg"
import broth from "./Industri-img/broth&co.png"
import medion from "./Industri-img/medion.jpg"
import toba from "./Industri-img/TobaSurimiIndustries.png"
import jmkp from "./Industri-img/JMKP.png"
import psu from "./Industri-img/PakanSehatUnggul.png"
import bbs from "./Industri-img/BBS.png"
import indowalet from "./Industri-img/IndowaletLestari.png"
import leonghup from "./Industri-img/LeongHupJayaindo.png"


import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css"
import "swiper/css/autoplay"
import { Autoplay } from "swiper/modules"

const Industri = () => {
  const allLogos = [
    KAIservice,
    Halal,
    pigeon,
    sababay,
    BUSKIPM,
    racelia,
    indmira,
    kkp,
    prakerja,
    pingroun,
    broth,
    minaceria,
    kemenperin,
  ]
  const allLogos2 = [
    intrafood, pertamina, casfood, medion, toba, jmkp, psu, bbs, indowalet, leonghup, trn,
  ]

  return (
    <>
      <div className="top" data-aos="fade-up">
        <h1 className={styles.tittle}>Klien Kami</h1>
        <p className={styles.text}>
          Mindo Education telah dipercaya untuk menyelenggarakan inhouse
          training <br /> 
          dan konsultasi sertifikasi oleh perusahaan dan instansi
          terkemuka
        </p>
      </div>

      <div className={styles.Industri} data-aos="fade-up">
        {/* Baris pertama */}
        <Swiper
          slidesPerView={5}
          spaceBetween={8}
          loop={true}
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
            reverseDirection: false,
          }}
          speed={2000}
          freeMode={true}
          modules={[Autoplay]}
          className="mySwiper"
          breakpoints={{
            0: {
              // 0px ke atas
              slidesPerView: 3,
            },
            601: {
              // 601px ke atas
              slidesPerView: 4,
            },
            835: {
              // 835px ke atas
              slidesPerView: 5,
            },
          }}>
          {allLogos.map((logo, index) => (
            <SwiperSlide key={`row1-${index}`}>
              <Card size="small" className={styles.cardLogo}>
                <img
                  src={logo}
                  alt={`logo-${index}`}
                  className={styles.logoIndustri}
                />
              </Card>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Baris kedua */}
        <Swiper
          slidesPerView={5}
          spaceBetween={8}
          loop={true}
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
            reverseDirection: false,
          }}
          speed={2000}
          freeMode={true}
          modules={[Autoplay]}
          className={`mySwiper swiper-row2`}
          breakpoints={{
            0: {
              // 0px ke atas
              slidesPerView: 3,
            },
            601: {
              // 601px ke atas
              slidesPerView: 4,
            },
            835: {
              // 835px ke atas
              slidesPerView: 5,
            },
          }}>
          {allLogos2.map((logo, index) => (
            <SwiperSlide key={`row2-${index}`}>
              <Card size="small" className={styles.cardLogo}>
                <img
                  src={logo}
                  alt={`logo-${index}`}
                  className={styles.logoIndustri}
                />
              </Card>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </>
  )
}

export default Industri
